import { render, staticRenderFns } from "./EvaluateUser.vue?vue&type=template&id=89a35f68"
import script from "./EvaluateUser.vue?vue&type=script&lang=js"
export * from "./EvaluateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports